import * as Yup from 'yup'

export function ValidateForm(values) {
    return Yup.object().shape({
        message: Yup.string().required('This field is required'),
    });
}
